(() => {
  const menuSelector = 'ul[data-buddha-menu]';

  function configureMenuTarget() {
    // Liquid only marks this target for authenticated B2B customers.
    // An empty match leaves the public navigation and footer untouched.
    window.customMenuUls = menuSelector;

    const menu = document.querySelector(menuSelector);
    if (!menu) return false;

    let schema = window.mmSchemaDesignJSON;
    if (typeof schema === 'string') {
      try {
        schema = JSON.parse(schema);
      } catch (error) {
        return false;
      }
    }
    if (!Array.isArray(schema)) return false;

    // Select the Shopify navigation being replaced, not Buddha's content.
    // Keep every design setting and the app-generated template unchanged.
    const menuHandle = menu.dataset.buddhaMenu;
    if (!menuHandle) return false;

    let hasMenuSelection = false;
    window.mmSchemaDesignJSON = schema.map((setting) => {
      if (setting.action !== 'menu-select') return setting;
      hasMenuSelection = true;
      return { ...setting, value: menuHandle };
    });
    if (!hasMenuSelection) {
      window.mmSchemaDesignJSON.push({ action: 'menu-select', value: menuHandle });
    }

    window.burgerIcon = '.main-menu__toggle';
    return true;
  }

  // Buddha calls this after its theme integration and before menu selection.
  const previousBeforeInit = window.mmCustomerFixesBeforeInit;
  window.mmCustomerFixesBeforeInit = function (...args) {
    const result = typeof previousBeforeInit === 'function'
      ? previousBeforeInit.apply(this, args)
      : undefined;
    configureMenuTarget();
    return result;
  };

  function applyToInitializedMenu() {
    const hasTarget = configureMenuTarget();
    if (!hasTarget || window.initializedSchema !== true
      || typeof window.mmWireframe !== 'string' || !window.mmWireframe
      || typeof window.applyMegaMenu !== 'function'
      || typeof window.applyOnClick !== 'function') return;

    // Also cover an app script that finished before this integration loaded.
    // Buddha handles insertion, native-item hiding, events and responsive layout.
    window.applyMegaMenu();
    window.applyOnClick();
  }

  applyToInitializedMenu();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector(menuSelector)) applyToInitializedMenu();
  });
})();
